import axios from "axios";

const api = process.env.REACT_APP_API_EVENTOS || "";

const consultarEventos = async (
  startDate = null,
  endDate = null,
  starKey = null,
  token,
  team = null
) => {
  const path = "/events"; // Ruta del evento específico
  const apiUrl = `${api}${path}`;
  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },

      params: {
        startDate: startDate,
        endDate: endDate,
        startKey: JSON.stringify(starKey),
        limit: 300,
        ...(team ? { team } : {}),
      },
    });
    // console.log(response);
    return response.data;
  } catch (error) {
    console.log("Error al consultar eventos:", error);
    throw error;
  }
};

const consultarEventoParticular = async (eventId, token) => {
  const path = `/events/${eventId}`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar evento particular:", error);
    throw error;
  }
};

const crearEvento = async (registro, token) => {
  const path = `/events`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.post(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al crear evento:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const EditarEvento = async (eventId, registro, token) => {
  const path = `/events/${eventId}`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.patch(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Devolver los datos obtenidos from Axios response.data
  } catch (error) {
    console.error("Error:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

// Reemplaza los datos iniciales del evento (los mismos que se envían al crearlo).
// Solo aplica mientras el evento está en estado "Open".
const actualizarEventoInicial = async (eventId, registro, token) => {
  const path = `/events/${eventId}`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.put(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Devolver los datos obtenidos from Axios response.data
  } catch (error) {
    console.error("Error al actualizar evento:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};
// funciones de las cuasas

const consultarCausas = async (eventId = null, token) => {
  let path = `/events/causes`; // Ruta del evento específico

  if (eventId) path = `/events/${eventId}/causes`;
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar evento particular:", error);
    throw error;
  }
};

const consultarTiposCausas = async (token = null) => {
  let path = `/events/causes/types`; // Ruta del evento específico

  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar evento particular:", error);
    throw error;
  }
};

const AsignarCausas = async (eventId, registro, token) => {
  const path = `/events/${eventId}/causes`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.post(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Devolver los datos obtenidos from Axios response.data
  } catch (error) {
    console.error("Error:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const ActualizarCausa = async (eventId, registro, token) => {
  const path = `/events/${eventId}/causes`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.patch(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // Devolver los datos obtenidos from Axios response.data
  } catch (error) {
    console.error("Error:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const EliminarCausa = async (eventId, registro, token) => {
  const path = `/events/${eventId}/causes`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.delete(apiUrl, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify(registro), // Convertir el objeto de registro a una cadena JSON
    });

    return response.data; // Devolver los datos obtenidos de Axios response.data
  } catch (error) {
    console.error("Error:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};
// funciones implicados

const consultarImplicados = async (eventId = null, cuase = null, token) => {
  let path = `/events/${eventId}/causes/involved`; // Ruta del evento específico

  if (cuase)
    path = `/events/${eventId}/causes/involved?protocol_cause_id=${cuase}`;
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar evento particular:", error);
    throw error;
  }
};

const crearImplicado = async (eventId, registro, token) => {
  const path = `/events/${eventId}/causes/involved`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.post(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al crear evento:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const editarImplicado = async (eventId, registro, token) => {
  const path = `/events/${eventId}/involved`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.patch(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al crear evento:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const eliminarImplicado = async (eventId, registro, token) => {
  const path = `/events/${eventId}/causes/involved`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.delete(apiUrl, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify(registro), // Convertir el objeto de registro a una cadena JSON
    });

    return response.data; // Devolver los datos obtenidos de Axios response.data
  } catch (error) {
    console.error("Error:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const consultarReportes = async (eventId = null, token) => {
  let path = `/events/${eventId}/report`; // Ruta del evento específico

  if (eventId) path = `/events/${eventId}/report`;
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al consultar evento particular:", error);
    throw error;
  }
};

// const consultarParticipantes = async (token) => {
//   let path = `/Participants`; // Ruta del evento específico

//   const apiUrl = `${api}${path}`;

//   try {
//     const response = await axios.get(apiUrl, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         Accept: "application/json",
//       },
//     });
//     return response.data; // Devolver los datos obtenidos
//   } catch (error) {
//     console.error("Error al consultar evento particular:", error);
//     throw error;
//   }
// };

const crearParticipante = async (registro, token) => {
  const path = `/participants`; // Ruta del evento específico
  const apiUrl = `${api}${path}`;

  try {
    const response = await axios.post(apiUrl, registro, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devolver los datos obtenidos
  } catch (error) {
    console.error("Error al crear evento:", error);
    throw error; // Relanzar el error para que se maneje en otro lugar si es necesario
  }
};

const consultarParticipantes = async (token) => {
  const path = "/participants"; // Ruta del evento específico
  const apiUrl = `${api}${path}`;
  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    // console.log(response);
    return response.data;
  } catch (error) {
    console.log("Error al consultar eventos:", error);
    throw error;
  }
};

const eventService = {
  crearEvento,
  consultarEventos,
  EditarEvento,
  actualizarEventoInicial,
  consultarEventoParticular,
  consultarCausas,
  consultarImplicados,
  crearImplicado,
  editarImplicado,
  AsignarCausas,
  ActualizarCausa,
  EliminarCausa,
  eliminarImplicado,
  consultarReportes,
  consultarTiposCausas,
  consultarParticipantes,
  crearParticipante,
};

export default eventService;
